import {createSlice} from '@reduxjs/toolkit';
import {deviceConnectionStatusTypes} from 'iqos-mw';

const getInitialState = () => {
    return {
        deviceName: undefined,
        charger: {
            connectionStatus: deviceConnectionStatusTypes.DISCONNECTED,
        },
        holder: {
            connectionStatus: deviceConnectionStatusTypes.DISCONNECTED,
        },
        connectionError: undefined,
    };
};

export const slice = createSlice({
    name: 'mw',
    initialState: getInitialState(),
    reducers: {
        resetMwState: () => {
            return {
                state: getInitialState(),
            };
        },
        setDeviceName: (state, action) => {
            return {
                ...state,
                deviceName: action.payload,
            };
        },
        setDeviceInitializationData: (state, action) => {
            const {charger, holder} = action.payload;

            return {
                ...state,
                charger: {
                    ...state.charger,
                    ...charger,
                },
                holder: {
                    ...state.holder,
                    ...holder,
                },
            };
        },
        setHolderInitializationData: (state, action) => {
            const holder = action.payload;

            return {
                ...state,
                holder: {
                    ...state.holder,
                    ...holder,
                },
            };
        },
        setConnectionError: (state, action) => {
            return {
                ...state,
                connectionError: action.payload,
            };
        },
        setConnectionErrorAsRead: (state) => {
            return {
                ...state,
                connectionError: {
                    ...state.connectionError,
                    isNew: false,
                },
            };
        },
        setChargerConnectionStatus: (state, action) => {
            return {
                ...state,
                charger: {
                    ...state.charger,
                    connectionStatus: action.payload,
                },
            };
        },
        setHolderConnectionStatus: (state, action) => {
            return {
                ...state,
                holder: {
                    ...state.holder,
                    connectionStatus: action.payload,
                },
            };
        },
        clearHolderMwData: (state) => {
            return {
                ...state,
                holder: {
                    connectionStatus: deviceConnectionStatusTypes.DISCONNECTED,
                },
            };
        },
    },
});

export const {
    clearHolderMwData,
    resetMwState,
    setDeviceName,
    setDeviceInitializationData,
    setHolderInitializationData,
    setConnectionError,
    setConnectionErrorAsRead,
    setChargerConnectionStatus,
    setHolderConnectionStatus,
} = slice.actions;

export default slice.reducer;
